import api from "../../../services/api"
//import { initialize } from "redux-form"
import { toastr } from "react-redux-toastr"
import axios from "axios"
import Baseurlaxios from "../../../services/baseurlaxios"

//const INITIAL_FORM_VALUES = {}

export function getData(TipoUsuSolicitante, CodPuxada) {
   
    return (dispatch) => {
        api.get(`/Usuario/TodosUsuarios?TipoUsuSolicitante=${TipoUsuSolicitante}&CodPuxada=${CodPuxada}`
        )
            .then(response => {
                dispatch({
                    type: "GET_DATA_USUARIO",
                    payload: response
                })
            })
            .catch(error => {
                toastr.error("Erro CadastroActions getData: " + error)
            })
    }
}

export function getCadAcsEmail() {
    return (dispatch) => {
        axios.get(`${Baseurlaxios}/MenuUsuario/BuscaAcessosEmail`)
            .then(response => {
                dispatch({
                    type: "GETDTACSDOEMAILCAD",
                    payload: response
                })
            })
            .catch(error => {
                toastr.error("Erro CadastroActions getCadAcsEmail: " + error)
            })
    }
}

// export function getDataFiltro(filtro) {
//     return (dispatch) => {
//         axios.get(`${Baseurlaxios}/Usuario/FiltroUsuarios/${filtro}`
//         )
//             .then(response => {
//                 dispatch({
//                     type: "GET_DATA_USUARIO_FILTRO",
//                     payload: response
//                 })
//             })
//             .catch(error => {
//                 toastr.error("Erro CadastroActions getDataFiltro: " + error)
//             })
//     }
// }

export function getExisteEmail(email) {
    return (dispatch) => {
        api.get(`/Usuario/ExisteEmail/${email}`
        )
            .then(response => {
                dispatch({
                    type: "GET_DATA_EXISTE_EMAIL",
                    payload: response
                })
            })
            .catch(error => {
                toastr.error("Erro CadastroActions getExisteEmail: " + error)
            })
    }
}

export function getExcUpdataUsu(value,TipoUsuSolicitante, CodPuxada) {
    return (dispatch) => {
        api.put(`/Usuario/UpdataExc/${value}`
            , {
                "usuid": value
            })
            .then(response => {
                dispatch(
                    [getData(value,TipoUsuSolicitante, CodPuxada )]
                )
                dispatch(
                    [getUsuCmps(TipoUsuSolicitante, CodPuxada)]
                )
            }
            )
            .catch(error =>
                toastr.error("Erro CadastroActions getExcUpdataUsu: " + error)
            )
    }
}

export function getBrokerCmps() {
    return (dispatch) => {
        axios.get(`${Baseurlaxios}/Tb_Dist/TodosDist`
        )
            .then(response => {
                dispatch({
                    type: "GET_CAMPOS_BRK",
                    payload: response
                })
            })
            .catch(error => {
                toastr.error("Erro CadastroActions getBrokerCmps: " + error)
            })
    }
}

export function getUsuCmps(TipoUsuSolicitante, CodPuxada) {
    return (dispatch) => {
        api.get(`/Usuario/TodosUsuarios?TipoUsuSolicitante=${TipoUsuSolicitante}&CodPuxada=${CodPuxada}`
        )
            .then(response => {
                dispatch({
                    type: "GET_CAMPOS_USU",
                    payload: response
                }

                )
            })
            .catch(error => {
                toastr.error("Erro CadastroActions getUsuCmps: " + error)
            })
    }
}

export function postInclui(
    USUID
    , USULOGIN
    , USUSENHA
    , USUEXC
    , acessosdoEmailSlv
    , tipo_Usu
    , cod_puxada
    , TipoUsuSolicitante
    , OriCodPuxada
) {
    return (dispatch) => {
        api.post(`/Usuario/incluiUsu`, {
            USUID
            , USULOGIN
            , USUSENHA
            , USUEXC
            , tipo_Usu
            , cod_puxada
        }
        )
            .then(response => {

                // toastr.success("Inclusão salva com sucesso")

                dispatch(
                    [postIncluiAcessos(USULOGIN,acessosdoEmailSlv,TipoUsuSolicitante,OriCodPuxada)]
                )
                dispatch(
                    [getUsuCmps(TipoUsuSolicitante,OriCodPuxada )]
                )
                dispatch(
                    [getCadAcsEmail()]
                )


            })
            .catch(error => {
                toastr.error("Erro ao salvar CadastroActions postInclui: " + error)
            })
    }

}
export function putSalva(USUID
    , USULOGIN
    , USUSENHA
    , USUEXC
    , acessosdoEmailSlv
    , tipo_Usu
    , cod_puxada
    , TipoUsuSolicitante
    , OriCodPuxada
) {
    return (dispatch) => {
        api.put(`/Usuario`, {
            USUID
            , USULOGIN
            , USUSENHA
            , USUEXC
            , tipo_Usu
            , cod_puxada
        }
        )
            .then(response => {
                //  toastr.success("Alteração salva com sucesso")
                dispatch(
                    [postIncluiAcessos(USULOGIN,acessosdoEmailSlv,TipoUsuSolicitante,OriCodPuxada)]
                )
                dispatch(
                    [getUsuCmps(TipoUsuSolicitante,OriCodPuxada )]
                )
                dispatch(
                    [getCadAcsEmail()]
                )

            })
            .catch(error => {
                toastr.error("Erro ao salvar CadastroActions putSalva: " + error)
            })

    }
}

export function postIncluiAcessos(email, Permissoesusuario, TipoUsuSolicitante,OriCodPuxada) {
    return (dispatch) => {
        api.post(`/MenuUsuario/ExcincluiUsuAcs?email=${email}&Permissoesusuario=${Permissoesusuario}`, {
        }
        )
            .then(response => {
                // atencao
                // recolocar e retirar quando passaAcessos estiver FUNCIONANDO
                // retirar do putsalva e do postinclui

                toastr.success("Alteração salva com sucesso")
                dispatch(
                    [getData(TipoUsuSolicitante,OriCodPuxada )]
                )
                dispatch(
                    [getUsuCmps(TipoUsuSolicitante,OriCodPuxada )]
                )
                dispatch(
                    [getCadAcsEmail()]
                )

            })
            .catch(error => {
                toastr.error("Erro ao salvar CadastroActions postIncluiAcessos: " + error)
            })
    }
}

// export function showFormAction(bShowForm) {
//     //bShowForm: TRUE: Exibir FORM / FALSE: Exibir LISTA
//     return {
//         type: "SHOW_FORM",
//         payload: bShowForm
//     }
// }

// export function initForm(values = INITIAL_FORM_VALUES) {
//     return initialize("frmCRUDCadastro", values) //MIDDLEWARE REDUX-THUNK
// }

